import { RootState } from '../../store/store';
import { LOBBY_KEY } from './slice';

export const getLobbyState = (state: RootState) => state[LOBBY_KEY];
export const getLobbyStateHallGameTypeMap = (state: RootState) =>
    getLobbyState(state).hallGameTypeMap;
